import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchProjectPaymentDetails } from '../../actions/additional_actions';
import { getDateValue } from '../../utils/date';
import { formatMoney } from '../../utils/budget';
import { FaFileExcelO } from 'react-icons/lib/fa';
import { withAuth } from '../../actions/';

class ProjectPayments extends Component {
    // static PropTypes = {
    //     payments: PropTypes.array.isRequired,
    // }

    constructor(props) {
        super(props);

        this.state = {
            contract: {},    
            currentPage: 1,
            itemsPerPage: 10     
        }

        this.handleClick = this.handleClick.bind(this);
        this.changeNumItemsShown = this.changeNumItemsShown.bind(this);
    }

    UNSAFE_componentWillMount() {
      
        this.props.fetchProjectPaymentDetails(this.props.projectId);
        this.handleExportToExcel = this.handleExportToExcel.bind(this);        
       
    }
    componentDidUpdate(prevProps) {
        if (prevProps.projectId !== this.props.projectId) {
            this.props.fetchProjectPaymentDetails(this.props.projectId);
       
        }
      }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.payments !== nextProps.payments)
        this.setState({ payments: nextProps.payments })
    }
    handleClick(event) {
        this.setState({
          currentPage: Number(event.target.id)
        });
      } 
    
        changeNumItemsShown(e) {
            if (e.target.value < 10 || e.target.value > this.props.payments.length ){
                           }
            else {
                    this.setState({ itemsPerPage: e.target.value });                
            }
        }

    handleExportToExcel() {
        
        // pass project Id 

           const projectId = this.props.projectId;
          
            
             let url = `projects/${projectId}/ExportPrjPaymentDetails`;
             let method = 'post'; 
             let responseType = 'arraybuffer';
    
             withAuth(
               { method, url, responseType },
               (response) => {
                 var data = response.data;
                 var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                 var blob = new Blob([data], { type: contentType }); 
                 var downloadUrl= window.URL.createObjectURL(blob);
                    var link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download='PaymentDetails.xlsx';
                    link.click();
               },
               this.errorHandler
             )
           }
           
    render() {

const { currentPage, itemsPerPage } = this.state;

// Logic for displaying items
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentPayments = this.props.payments.slice(indexOfFirstItem, indexOfLastItem);

// Logic for displaying page numbers
const pageNumbers = [];
for (let i = 1; i <= Math.ceil(this.props.payments.length / itemsPerPage); i++) {
    pageNumbers.push(i);
}

        return (


            <div id="blueBook">
            {currentPayments.length > 0 ?
                <div className="row-wide">
                    <div className="col s12">
                    <button className="btn-save btn-excel float-right margin-top-035" onClick={this.handleExportToExcel}>
                            <span className="margin-right-05"> <FaFileExcelO size={18} color='#008000' /></span>
                            Excel</button>
                        <h4 className="bar-bottom">Payment Details</h4>  
                    </div>   
                    <div className="col s12">
                        <div className="table paytable">
                            <table className="table-striped">
                            <thead>
                                    <tr>
                                        <th>Payment #</th>
                                        <th>FMSID</th>
                                        <th>Registration #</th>
                                        <th>Source System</th>
                                        <th>Payment Request Date</th>
                                        <th>Payment Status</th>
                                        <th>Payment Type</th>
                                        <th>Original Amount Required</th>
                                        <th>CFO Revised Amount</th>
                                        <th>FMS System Date</th>
                                        <th>FMS Check Date</th>
                                        <th>Invoice Date</th>
                                        <th>Voucher #</th>    
                                        <th>Work Flow Status</th> 
                                        <th>Work Flow Status Date</th>                                    
                                    </tr>
                                </thead>

                                <tbody>
                                  {  currentPayments.map((payment, index) => {
                                         return <tr key={index}>                            
                                        <td>{payment.payment_Number}</td>
                                        <td>{payment.fmsid}</td>
                                        <td>{payment.contract_Reg_Number}</td>
                                        <td>{payment.srs}</td>
                                        <td>{getDateValue(payment.payRequestDate)}</td>
                                        <td>{payment.pay_Status}</td>
                                        <td>{payment.payment_Type}</td>
                                        <td>{formatMoney(payment.originalAmountReq)}</td>
                                        <td>{formatMoney(payment.cfO_rev_amt)}</td>
                                        <td>{getDateValue(payment.fisaSysDate)}</td>
                                        <td>{getDateValue(payment.fisaChkDate)}</td>
                                        <td>{getDateValue(payment.invoiceDate)}</td>
                                        <td>{payment.voucherNo}</td>    
                                        <td>{payment.current_Step}</td>                                                     
                                        <td>{getDateValue(payment.step_Date)}</td>                                                              
                                    </tr>
                                  })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {pageNumbers.length > 1 &&
                    <div>
                        <div className="col s12">
                            <div className="controls margin-top-1">
                                <label className="label-pagination">Show</label>
                                <input type="number" value={itemsPerPage} onChange={this.changeNumItemsShown}
                                    min="10" max={this.props.payments.length - 1} className="input-pagination" />
                                <span className="label-pagination">Records</span>
                            </div>
                        </div>

                        <div className="col s12">
                            <div className="pagination-blue-book">
                                <ul id="page-numbers">
                                    {pageNumbers.map(number => {
                                        return <li
                                            key={number}
                                            id={number}
                                            onClick={this.handleClick}
                                            className={currentPage === number ? 'active' : ''}
                                        >
                                            {number}
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                }
                </div>
                :  <div className="noData">
                     No Payments are found for this contract.
                 </div>}
            </div>
        );
    }
}

ProjectPayments.propTypes = {
    payments: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        payments: state.additionalProjectsStore.allPrjPayments,
        projectId: ownProps.projectId
    };
}

export default connect(mapStateToProps, { fetchProjectPaymentDetails })(ProjectPayments);